import type { Module } from "@webmotors/ioc";
import { UserDataQuery } from "./user-data.query";

export const QUERIES_MODULE = "QUERIES_MODULE";

export const QueriesModule: Module = {
  name: QUERIES_MODULE,
  providers: [UserDataQuery],
};
